import React from 'react';
import { Link } from 'react-router-dom';

const CodexItem = (props) => (
    <div>
        <Link to={"/codex/"+props.page.slug}>
            {
            props.page.parent === null ? (
                <h2>{props.page.title}</h2>
            ) : (
                <h3>{props.page.title}</h3>
            )
            }
        </Link>
        { props.page.children ? (
        <div style={{marginLeft:'25px'}}>
        {
            props.page.children
                .sort((a, b) => a.order - b.order)
                .map((page) => {return props.codex[page]})
                .map((page) => (
                    <CodexItem page={page} codex={props.codex} />
            ))
        }
        </div>
        ) : null
        }
    </div>
);


export default CodexItem;


// WEBPACK FOOTER //
// ./src/Media/CodexItem.js